import { styled } from 'baseui'
import { FlexCenterY } from '@/shared/theme/styled-components'

export const StyledContainer = styled('div', ({ $theme, $completed }) => ({
  width: '100%',
  border: `0.1rem solid ${$completed ? $theme.colors.warning400 : 'transparent'}`,
  borderRadius: '0.5rem',
}))

export const CreditPill = styled('span', ({ $theme, $completed }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  height: '1.5rem',
  paddingLeft: '0.5rem',
  paddingRight: '0.5rem',
  borderRadius: '999px',
  backgroundColor: $completed ? $theme.colors.positive50 : $theme.colors.bg050,
  color: $completed ? $theme.colors.positive600 : $theme.colors.primary,
  fontWeight: 700,
  fontSize: '0.8125rem',
  lineHeight: '1.5rem',
}))

export const CreditPillIcon = styled('img', {
  width: '0.875rem',
  height: '0.875rem',
  marginRight: '0.25rem',
})

export const StyledCurrentValue = styled('span', ({ $theme, $reachedMax }) => ({
  color: $reachedMax ? $theme.colors.positive600 : 'inherit',
}))

export const StyledMaxValue = styled('span', {
  fontWeight: 500,
  opacity: 0.7,
})

export const GaugeSection = styled('div', {
  paddingTop: 0,
  paddingBottom: '0.75rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
})

export const GaugeSegments = styled('div', {
  display: 'flex',
  gap: '0.125rem',
  width: '100%',
  height: '0.375rem',
})

export const GaugeSegment = styled('span', ({ $theme, $sold, $weight }) => ({
  flexGrow: $weight,
  flexBasis: 0,
  minWidth: '0.375rem',
  borderRadius: '999px',
  backgroundColor: $sold ? $theme.colors.positive500 : $theme.colors.bg050,
  transition: 'background-color 0.4s ease',
}))

export const QuestList = styled('div', ({ $theme, $hidden }) => ({
  display: $hidden ? 'none' : 'flex',
  flexDirection: 'column',
  paddingTop: '0.375rem',
  paddingBottom: '0.5rem',
  paddingLeft: '0.5rem',
  paddingRight: '0.5rem',
  borderTop: `0.1rem solid ${$theme.colors.borderSoft}`,
}))

export const questIconOverrides = {
  Svg: {
    style: {
      width: '1.125rem',
      height: '1.125rem',
    },
  },
}

export const StyledEmptyMessageContainer = styled(FlexCenterY, {
  padding: '0rem 0.5rem 1rem 1rem',
})

export const StyledEmptyIcon = styled('img', () => ({
  width: 'auto',
}))

export const StyledEmptyText = styled('span', ({ $theme }) => ({
  paddingTop: '0.45rem',
  color: $theme.colors.grey,
}))
